<template>
  <v-container
    id="duo-care-list"
    fluid
    tag="section"
  >
    <div v-if="checkPermission('periodic-care-tab_read') || checkPermission('extend-tab_read')">
      <duo-care-top-bar
        class="mb-4"
        :studentsDuo="studentsDuo"
        :filterForm="filterForm"
        :totalItem="totalItem"
        :selected-item="selectedItem"
        @clear-item-selected="selectedItem = []"
        @change-tab="handleChangeTab"
      ></duo-care-top-bar>
      <care-module-count-table
        ref="careModuleCountTable"
        class="mb-4"
        :dataCallStatus="dataCallStatus"
        :typeHeaderStatusModule="typeHeaderStatusModule"
        :countStatusModuleList="countStatusModuleList"
        :totalDuoCareModule="totalDuoCareModule"
        :filterForm="filterForm"
      ></care-module-count-table>
      <duo-care-list-table
        :studentsDuo="studentsDuo"
        :otherData="studentsOtherDataDuo"
        :filterForm="filterForm"
        :selectedItem="selectedItem"
        @change-item-selected="handleChangeItemSelected"
        @clear-item-selected="selectedItem = []"
        @sortlist="sortListByMoc()"
        @viewedcontact="viewedContactCustomer($event)"
      ></duo-care-list-table>
    </div>
    <div v-else style="color: red; display: flex; justify-content: center">
      Không có dữ liệu
    </div>
  </v-container>
</template>

<script>
import checkPermission from '@/modules/student_care/mixins/checkPermission';
import { mapActions } from 'vuex';
import {
  ERROR_CODE_FORBIDDEN,
  ERROR_CODE_TOKEN_EXPIRED,
  ERROR_CODE_UNAUTHORIZED,
} from '@/helpers/constant';
import DuoCareListTable from './components/list/DuoCareListTable.vue';
import CareModuleCountTable from './components/CareModuleCountTable.vue';
import DuoCareTopBar from './components/DuoCareTopBar.vue';
import StudentCareServices from '../../services/StudentCareServices';

export default {
  components: {
    DuoCareListTable,
    CareModuleCountTable,
    DuoCareTopBar,
  },
  mixins: [checkPermission],
  data() {
    return {
      selectedItem: [],
      studentsDuo: [],
      filterForm: {
        openRowMenu: false,
        status: '',
        searchInfo: '',
        courseEndDate: [],
        courseEndDates: [],
        extend_at: [],
        subjectId: null,
        phoneNumber: '',
        page: 1,
        limit: 20,
        callIds: [],
        callStatusIds: [],
        headTeacher: [],
        subject_ids: [],
        openQuickView: true,
        historyCallIds: [],
        historyCallStatusId: [],
        checkboxAll: false,
        pendingPage: 1,
        sales: [],
        compareTypeNumberOfLessons: 'eq',
        numberOfLessons: null,
        noEndDate: false,
        hasNoTeacher: false,
        hasNoSale: false,
        class_start_time: [],
        previous_end_date: [],
        class_code: '',
        program_ids: [],
        type_curriculum: _.cloneDeep(this.$store.state.typeCurriculum),
        typeCustomerCare: 1,
        homeroomTeacherIds: [],
        userIds: [],
        historyCallStatusIds: [],
        productIds: [],
        sortUpdatedAt: 'asc',
        distributeDate: [],
        orderCreatedAt: [],
      },
      typeHeaderStatusModule: [],
      countStatusModuleList: [],
      dataCallStatus: [],
      totalDuoCareModule: 0,
      totalItem: 0,
      studentsOtherDataDuo: [],
    };
  },
  async created() {
    if (this.$store.state.permissions.some((e) => e === 'periodic-care-tab_read')) {
      this.filterForm.typeCustomerCare = 1;
    } else {
      this.filterForm.typeCustomerCare = 2;
    }
    Bus.$on('duo-care-list-filter', (changeTab) => {
      if (changeTab) {
        this.getListStatus(this.filterForm);
      }
      this.searchRecords();
    });
    Bus.$on('duo-care-list-no-count-filter', () => {
      this.getList(this.filterForm);
    });
  },
  beforeDestroy() {
    Bus.$off('duo-care-list-filter');
    Bus.$off('duo-care-list-no-count-filter');
  },
  methods: {
    ...mapActions('contact_status', ['getListStatus']),
    handleChangeTab() {
      this.$refs.careModuleCountTable.isActive = 'all';
    },
    handleChangeItemSelected(item, action) {
      if (action === 'add') {
        this.selectedItem.push(item);
      } else if (action === 'remove') {
        const index = this.selectedItem.findIndex((e) => e.id === item.id);
        if (index > -1) {
          this.selectedItem.splice(index, 1);
        }
      }
    },
    checkPermission(permission) {
      return this.$store.state.permissions.some((e) => e === permission);
    },
    async searchRecords() {
      if ((this.filterForm.typeCustomerCare === 1 && this.checkPermission('periodic-care-tab_read')) || (this.filterForm.typeCustomerCare === 2 && this.checkPermission('extend-tab_read'))) {
        this.appLoadingData(true, 0);
        this.filterForm.page = 1;
        this.filterForm.pendingPage = 1;
        await Promise.all([
          this.getList(this.filterForm),
          this.getCount(this.filterForm),
        ]);
        this.appLoadingData(false, 0);
      } else {
        this.$swal.fire({
          text: 'Bạn không có quyền truy cập trang này, vui lòng liên hệ Admin !',
        });
      }
    },
    async getList() {
      this.studentsDuo = null;
      this.studentsOtherDataDuo = null;
      const res = await StudentCareServices.getListDuoCare(this.filterForm);
      if (res?.success) {
        this.studentsDuo = res?.data.map((e) => ({
          ...e,
          routine_student_list: e.routine_student_list.map((item) => ({
            ...item,
            checkbox: false,
            routine_history_json: item.routine_history_json ? JSON.parse(item.routine_history_json).slice(-5) : item.routine_history_json,
          })),
        }));
        this.studentsOtherDataDuo = res.otherData;
        this.totalItem = this.studentsDuo.length;
      } else if (res.status === ERROR_CODE_FORBIDDEN || res.status === ERROR_CODE_TOKEN_EXPIRED || res.status === ERROR_CODE_UNAUTHORIZED) {
        await window.location.replace('/error-403');
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res?.message,
        });
      }
    },
    async getCount() {
      const res = await StudentCareServices.getCountDuoCare(this.filterForm);
      if (res?.success) {
        this.handleDataCount(res?.data);
      } else if (res.status !== ERROR_CODE_FORBIDDEN && res.status !== ERROR_CODE_TOKEN_EXPIRED && res.status !== ERROR_CODE_UNAUTHORIZED) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res?.message,
        });
      }
    },
    handleDataCount(data) {
      const typeHeaderStatusModule = [];
      const countStatusModuleList = [];
      let totalContact = 0;
      data.forEach((item) => {
        const itemIds = [];
        let totalCountStatus = 0;
        const headerObject = {
          name: item.name, colspan: item.data.length ? item.data.length : 1, code: null, typeId: item.id,
        };
        typeHeaderStatusModule.push(headerObject);
        if (!item.data.length) {
          countStatusModuleList.push({
            type: item.name, id: 0, noContact: '', name: '', typeId: item.id, color: '#ffffff',
          });
        }
        item.data.forEach((itemCountStatus) => {
          itemIds.push(itemCountStatus.id);
          totalCountStatus += parseInt(itemCountStatus.no, 10);
          totalContact += parseInt(itemCountStatus.no, 10);
          const bodyObject = {
            type: item.name, id: itemCountStatus.id, noContact: itemCountStatus.no, name: itemCountStatus.name, typeId: itemCountStatus.typeId, color: itemCountStatus.color,
          };
          countStatusModuleList.push(bodyObject);
        });
        // eslint-disable-next-line no-param-reassign
        item.no = totalCountStatus;
        // item.data.unshift({
        //   id: itemIds,
        //   name: 'Tất cả',
        //   color: '#739A77',
        //   typeId: item.id,
        //   no: totalCountStatus,
        // });
      });
      this.typeHeaderStatusModule = typeHeaderStatusModule;
      this.countStatusModuleList = countStatusModuleList;
      this.totalDuoCareModule = totalContact;
      this.dataCallStatus = data;
    },
    sortListByMoc() {
      this.filterForm.sortUpdatedAt = this.filterForm.sortUpdatedAt === 'asc' ? 'desc' : 'asc';
      this.getList(this.filterForm);
    },
    async viewedContactCustomer(contact) {
      await StudentCareServices.updateIsNewCall(contact.id);
      this.getList(this.filterForm);
    },
  },
  computed: {

  },
  watch: {

  },
};
</script>

<style scoped lang="css">
#duo-care-list {
  background-color: #eff0f6;
}
</style>
